export const equal = (value, equal) => {
    if (!!value && +value !== +equal) {
        return `Должно быть равно ${equal}`;
    }
    return null;
};
